/*
Created-by: XtroEdge AI
Updated-by: XtroEdge AI
Last modified: 2026-11-03T11:21:00-08:00
Intent: Fold the old /home/contests… addresses onto /home/campaigns….
*/

/**
 * The campaign pages moved from /home/contests, /home/contest-type and
 * /home/contest-submission-* to the same addresses spelt "campaign". The server's page list
 * (dashboard_pages / my_permissions) and old bookmarks may still carry the old ones, so any
 * comparison against a route folds both sides through here first.
 *
 * Only absolute paths are touched — "contests" on its own is a page KEY, not an address.
 */
const LEGACY_CAMPAIGN_ROUTE =
  /^\/home\/contest(?=(?:s|-type|-submission-success|-submission-failed)(?:[/?#]|$))/i;

export function toCampaignRoute(path: string): string {
  return (path || '').replace(LEGACY_CAMPAIGN_ROUTE, '/home/campaign');
}
